import { createContext } from 'react'

/**
 * Application context interface
 */
export interface Application {
  refresh: () => void
}

/**
 * Application context for platform pages
 */
export const AppContext = createContext<Application>(null as any)
